import React, { Fragment, useRef, useState } from "react";
import {
  Chip,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  useTheme,
} from "@mui/material";
import {
  PsychologyRounded,
  BoltRounded,
  ArrowDropDownRounded,
} from "@mui/icons-material";
import { makeStyles } from "tss-react/mui";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { toggleThinkingModeSuccess } from "../../../../../core/events/accountEvents";

const useStyles = makeStyles()((theme) => ({
  modeChip: {
    color: theme.palette.text.primary,
    "& .MuiChip-icon": {
      color: theme.palette.text.primary,
    },
    "& .MuiChip-deleteIcon": {
      color:
        theme.palette.mode === "dark" ? theme.palette.text.primary : "initial",
    },
  },
  activeModeChip: {
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.primary.main : "#E1BEE7",
    color: theme.palette.mode === "dark" ? "#092728" : "#9C27B0",
    "& .MuiChip-icon": {
      color: theme.palette.mode === "dark" ? "#092728" : "#9C27B0",
    },
    "&:hover": {
      backgroundColor:
        theme.palette.mode === "dark" ? theme.palette.primary.main : "none",
    },
    "& .MuiChip-deleteIcon": {
      color: theme.palette.mode === "dark" ? "#092728" : "initial",
    },
  },
}));

function ThinkingModeChip() {
  const theme = useTheme();
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const { thinkingMode } = useSelector((state) => state.account);
  const modeChipRef = useRef(null);
  const [modeAnchorEl, setModeAnchorEl] = useState(null);

  const handleModeChange = (event, value) => {
    if (!value) return;
    const enableThinking = value === "expert";
    if (enableThinking !== thinkingMode) {
      dispatch(toggleThinkingModeSuccess(enableThinking));
    }
  };

  const openModeMenu = (e) => {
    e.stopPropagation();
    setModeAnchorEl(modeChipRef.current);
  };
  const closeModeMenu = () => setModeAnchorEl(null);
  const selectMode = (value) => {
    handleModeChange(null, value);
    closeModeMenu();
  };

  return (
    <Fragment>
      <Chip
        ref={modeChipRef}
        className={thinkingMode ? classes.activeModeChip : classes.modeChip}
        label={thinkingMode ? "Expert" : "Normal"}
        icon={thinkingMode ? <PsychologyRounded /> : <BoltRounded />}
        onClick={openModeMenu}
        deleteIcon={<ArrowDropDownRounded />}
        onDelete={openModeMenu}
      />
      <Menu
        open={!!modeAnchorEl}
        anchorEl={modeAnchorEl}
        onClose={closeModeMenu}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "bottom", horizontal: "left" }}
        slotProps={{
          paper: {
            sx: {
              paddingY: 0.5,
              mt: -1,
              borderRadius: "10px",
              minWidth: 140,
              boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
            },
          },
        }}>
        <MenuItem onClick={() => selectMode("normal")} selected={!thinkingMode}>
          <ListItemIcon>
            <BoltRounded
              sx={{ fontSize: 18, color: theme.palette.text.secondary }}
            />
          </ListItemIcon>
          <ListItemText
            primary="Normal"
            primaryTypographyProps={{
              sx: { fontWeight: !thinkingMode ? 600 : 400 },
            }}
          />
        </MenuItem>
        <MenuItem onClick={() => selectMode("expert")} selected={thinkingMode}>
          <ListItemIcon>
            <PsychologyRounded
              sx={{
                fontSize: 18,
                // color: thinkingMode ? "#9748e8" : "#9C27B0",
              }}
            />
          </ListItemIcon>
          <ListItemText
            primary="Expert"
            primaryTypographyProps={{
              sx: {
                fontWeight: thinkingMode ? 600 : 400,
                // color: thinkingMode ? "#9748e8" : "inherit",
              },
            }}
          />
        </MenuItem>
      </Menu>
    </Fragment>
  );
}

export default ThinkingModeChip;
